const logotext = "Drew";
const meta = {
    title: "Drew Jordan",
    description: "Incident & Threat Analyst on Capital One's SOC and a cybersecurity graduate who builds and breaks things in a security-first homelab.",
};

const introdata = {
    // title: "I'm Drew Jordan",
    animated: {
        first: "Thinking like an attacker",
        second: "Defending like an analyst",
        third: "Building like an engineer",
    },
    description: "Incident & Threat Analyst on Capital One's Security Operations Center detecting, investigating, and responding to threats in real time.",
    your_img_url: "https://drive.google.com/file/d/1AZg0AXkGnIn44fY_Z9O8SbkJ77O64fNa/view?usp=sharing",
};

const dataabout = {
    title: "About me",
    aboutme: "I'm a cybersecurity professional who graduated from Loyola University Chicago in December 2025 with a B.S. in Cybersecurity. I work as an Incident & Threat Analyst on Capital One's Security Operations Center, where I detect, investigate, and respond to security threats, tune detections, and defend the network day to day. I got there through the Discover Financial Services SOC, joining full time in September 2025 before the Discover and Capital One SOC teams merged into one. Outside of work, I run a security-first homelab built around network segmentation and real-world operational discipline: Splunk for logging and detection, Dockerized services behind Cloudflare Tunnels, VLANs, split-horizon DNS, and monitoring stacks. It's where I sharpen my skills, research attacks and defenses, and stay hands-on. My development background in Python and JavaScript lets me bridge security and engineering, automating the work and understanding the systems I'm defending.",
};

const worktimeline = [
    {
        jobtitle: "Incident & Threat Analyst",
        what: "Full-time",
        where: "Capital One Financial",
        date: "2026 - Present",
    },
    {
        jobtitle: "Associate Incident & Threat Analyst",
        what: "Full-time",
        where: "Discover Financial Services",
        date: "Sept 2025 - Dec 2025",
    },
    {
        jobtitle: "Cloud Security Engineer",
        what: "Internship",
        where: "Discover Financial Services",
        date: "Summer 2025",
    },
    {
        jobtitle: "SOC Analyst",
        what: "Internship",
        where: "Discover Financial Services",
        date: "Summer 2024",
    },
    {
        jobtitle: "IT Support Specialist",
        what: "Part-time",
        where: "Loyola University Chicago",
        date: "2021 - 2024",
    },
];

// grouped skill tags — rendered as badges on the About page
const skills = [
    {
        title: "Security Operations",
        items: ["Incident Response", "Threat Detection", "Splunk / SIEM", "Intrusion Detection & Prevention", "Log Analysis", "Detection Engineering", "Network Defense"],
    },
    {
        title: "Infrastructure & Networking",
        items: ["Docker", "Proxmox", "Unraid", "Nginx Proxy Manager", "Cloudflare Tunnels", "Pi-hole / DNS", "VLAN Segmentation", "Prometheus & Grafana"],
    },
    {
        title: "Development & Automation",
        items: ["Python", "JavaScript", "React", "Node.js", "Bash", "PowerShell", "n8n"],
    },
    {
        title: "Platforms & Tooling",
        items: ["Linux", "Authentik SSO", "Git", "MongoDB", "Portainer"],
    },
];

const tools = [
    {
        name: "Cloud Platforms",
        description: "AWS, Azure, GCP, Wiz",
    },
    {
        name: "SIEM & EDR",
        description: "Splunk, SentinelOne, Demisto, Bricata",
    },
    {
        name: "Offensive Tools",
        description: "Nmap, Metasploit, sqlmap, Burp Suite",
    },
    {
        name: "Scripting & Automation",
        description: "Python, Bash, PowerShell, N8N",
    },
    {
        name: "Containers & Infra",
        description: "Docker, Linux, WireGuard, Git, Jenkins",
    },
    {
        name: "Monitoring & Logging",
        description: "Proofpoint, CrowdSec, UDM Pro SE, Pi-hole",
    },
];

// ponytail: ReverseDucky hidden — projects page shows homelab writeups only.
// Uncomment the entry below to bring non-homelab projects back.
// const dataportfolio = [
//     {
//         title: "ReverseDucky",
//         description: "A pen-testing proof of concept showing how quickly a hidden PowerShell reverse shell can be stood up with a USB Rubber Ducky. Demonstrates the HID attack path — payload staging, encoding, and a netcat listener — to illustrate why endpoint controls and physical security matter. For authorized testing only.",
//         tags: ["PowerShell", "Red Team", "HID Attack", "Pen Testing"],
//         link: "https://github.com/drewjordan414/ReverseDucky",
//     },
// ];
const dataportfolio = [];


const contactConfig = {
    YOUR_EMAIL: "drew@drewjordan.dev",
    description: "If you would like to learn more about my work and how I do it, please reach out to me via email. I am always happy to discuss my work and share my knowledge with others.",
    // creat an emailjs.com account
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    SERVICE_ID: "service_q80neuc",
    TEMPLATE_ID: "template_7q33hgq",
    USER_ID: "YyQF8LSqgc4Hh8Nf3eQrj",
};

const socialprofils = {
    github: "https://github.com/drewjordan414",
    linkedin: "https://www.linkedin.com/in/drew-jordan-103993221/",
    twitter: "https://x.com/drewjordandev",
};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    tools,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
